export var OfficeAchievementLevelStatus;
(function (OfficeAchievementLevelStatus) {
    OfficeAchievementLevelStatus["COMPLETED"] = "COMPLETED";
    OfficeAchievementLevelStatus["CURRENT"] = "CURRENT";
    OfficeAchievementLevelStatus["PENDING"] = "PENDING";
})(OfficeAchievementLevelStatus || (OfficeAchievementLevelStatus = {}));
//# sourceMappingURL=office-achievement-level-status.enum.js.map